import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ProductList from './components/ProductList';
import FormProduto from './components/FormProduto';
import UserList from './components/UserList';
import FormUsuario from './components/FormUsuario';
import PermissionProfileList from './components/PermissionProfileList';
import PermissionProfileForm from './components/PermissionProfileForm';
import CategoryList from './components/CategoryList';
import SubCategoryList from './components/SubCategoryList';
import ClientList from './components/ClientList';
import FormClient from './components/FormClient';
import TaxGroupList from './components/TaxGroupList';
import FormTaxGroup from './components/FormTaxGroup';
import NfeGerencialPage from './components/NfeGerencialPage';
import NfeXmlImportPage from './components/NfeXmlImportPage';
import NfeManifestoPage from './components/NfeManifestoPage';
import FiscalCatalogPage from './components/FiscalCatalogPage';
import ProtectedRoute from './components/ProtectedRoute';
import BrandList from './components/BrandList';
import FormBrand from './components/FormBrand';
import Layout from './components/Layout';
import SupplierList from './components/SupplierList';
import FormSupplier from './components/FormSupplier';
import TransportadoraList from './components/TransportadoraList';
import LocaisEstoquePage from './components/LocaisEstoquePage';
import TransferenciaEstoqueList from './components/TransferenciaEstoqueList';
import FormTransferenciaEstoque from './components/FormTransferenciaEstoque';
import StockMovementList from './components/StockMovementList';
import FormStockMovement from './components/FormStockMovement';
import CampaignList from './components/CampaignList';
import FormCampaign from './components/FormCampaign';
import PdvList from './components/PdvList';
import PdvForm from './components/PdvForm';
import EstabelecimentoList from './components/EstabelecimentoList';
import EstabelecimentoForm from './components/EstabelecimentoForm';
import PaymentMethodList from './components/PaymentMethodList';
import FormPaymentMethod from './components/FormPaymentMethod';
import PixIntegrationList from './components/PixIntegrationList';
import FormPixIntegration from './components/FormPixIntegration';
import ConvenioPage from './components/ConvenioPage';
import DevolucoesPage from './components/DevolucoesPage';
import CashSessionList from './components/CashSessionList';
import PreVendaList from './components/PreVendaList';
import PedidoComercialList from './components/PedidoComercialList';
import FormPedidoComercial from './components/FormPedidoComercial';
import Reports from './components/Reports';
import EstoqueSituacaoReport from './components/reports/EstoqueSituacaoReport';
import EstoqueDisponibilidadeReport from './components/reports/EstoqueDisponibilidadeReport';
import PlanejamentoComprasPage from './components/reports/PlanejamentoComprasPage';
import UtilitiesHub from './components/utilities/UtilitiesHub';
import CancellationsReport from './components/utilities/CancellationsReport';
import AbcCurveReport from './components/utilities/AbcCurveReport';
import FiscalDocumentsReport from './components/utilities/FiscalDocumentsReport';
import AuditReport from './components/utilities/AuditReport';
import ScaleLoadPage from './components/utilities/ScaleLoadPage';
import ProductExcelPage from './components/utilities/ProductExcelPage';
import ClientExcelPage from './components/utilities/ClientExcelPage';
import LabelsPage from './components/utilities/LabelsPage';
import LabelModelsPage from './components/utilities/LabelModelsPage';
import CopiarPrecosFilialPage from './components/utilities/CopiarPrecosFilialPage';
import ReajusteProdutosPage from './components/utilities/ReajusteProdutosPage';
import PdvErroLogsPage from './components/PdvErroLogsPage';
import TefCobrancaList from './components/TefCobrancaList';

// dentro das rotas protegidas:


function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

// Componente para diferenciar layout com e sem a Navbar
function AppLayout() {

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/:estabelecimento/login" element={<Login />} />

      {/* Rotas protegidas dentro do Layout */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="reports" element={<Reports />} />
        <Route path="reports/cancellations" element={<CancellationsReport />} />
        <Route path="reports/abc" element={<AbcCurveReport />} />
        <Route path="reports/fiscal-documents" element={<FiscalDocumentsReport />} />
        <Route path="reports/audit" element={<AuditReport />} />
        <Route path="reports/estoque-situacao" element={<EstoqueSituacaoReport />} />
        <Route path="reports/estoque-disponibilidade" element={<EstoqueDisponibilidadeReport />} />
        <Route path="reports/planejamento-compras" element={<PlanejamentoComprasPage />} />
        <Route path="reports/zenpay" element={<TefCobrancaList />} />
        <Route path="utilities" element={<UtilitiesHub />} />
        <Route path="utilities/cancellations" element={<Navigate to="/reports/cancellations" replace />} />
        <Route path="utilities/abc" element={<Navigate to="/reports/abc" replace />} />
        <Route path="utilities/scale-load" element={<ScaleLoadPage />} />
        <Route path="utilities/excel" element={<ProductExcelPage />} />
        <Route path="utilities/excel-clientes" element={<ClientExcelPage />} />
        <Route path="utilities/labels" element={<LabelsPage />} />
        <Route path="utilities/label-models" element={<LabelModelsPage />} />
        <Route path="utilities/pdv-erros" element={<PdvErroLogsPage />} />
        <Route path="utilities/copiar-precos-filial" element={<CopiarPrecosFilialPage />} />
        <Route path="utilities/reajuste-produtos" element={<ReajusteProdutosPage />} />
        <Route path="cash-sessions" element={<CashSessionList />} />
        <Route path="pre-vendas" element={<PreVendaList />} />
        <Route path="orcamentos" element={<PedidoComercialList tipoFixo="Orcamento" />} />
        <Route path="orcamentos/novo" element={<FormPedidoComercial tipoFixo="Orcamento" />} />
        <Route path="orcamentos/:id" element={<FormPedidoComercial isEditMode tipoFixo="Orcamento" />} />
        <Route path="orcamentos/:id/editar" element={<FormPedidoComercial isEditMode tipoFixo="Orcamento" />} />
        <Route path="pedidos-venda" element={<PedidoComercialList tipoFixo="Pedido" />} />
        <Route path="pedidos-venda/novo" element={<FormPedidoComercial tipoFixo="Pedido" />} />
        <Route path="pedidos-venda/:id" element={<FormPedidoComercial isEditMode tipoFixo="Pedido" />} />
        <Route path="pedidos-venda/:id/editar" element={<FormPedidoComercial isEditMode tipoFixo="Pedido" />} />
        <Route path="pedidos-comerciais" element={<Navigate to="/orcamentos" replace />} />
        <Route path="pedidos-comerciais/novo" element={<Navigate to="/orcamentos/novo" replace />} />
        <Route path="pedidos-comerciais/:id" element={<FormPedidoComercial isEditMode />} />
        <Route path="pedidos-comerciais/:id/editar" element={<FormPedidoComercial isEditMode />} />
        <Route path="products" element={<ProductList />} />
        <Route path="create-product" element={<FormProduto />} />
        <Route path="edit-product/:id" element={<FormProduto isEditMode />} />
        <Route path="users" element={<UserList />} />
        <Route path="create-user" element={<FormUsuario />} />
        <Route path="edit-user/:id" element={<FormUsuario isEditMode />} />
        <Route path="permission-profiles" element={<PermissionProfileList />} />
        <Route path="permission-profiles/new" element={<PermissionProfileForm />} />
        <Route path="permission-profiles/:id/edit" element={<PermissionProfileForm />} />
        <Route path="categories" element={<CategoryList />} />
        <Route path="create-category" element={<Navigate to="/categories" replace />} />
        <Route path="edit-category/:id" element={<Navigate to="/categories" replace />} />
        <Route path="subcategories" element={<SubCategoryList />} />
        <Route path="create-subcategory" element={<Navigate to="/subcategories" replace />} />
        <Route path="edit-subcategory/:id" element={<Navigate to="/subcategories" replace />} />
        <Route path="brands" element={<BrandList />} />
        <Route path="create-brand" element={<FormBrand />} />
        <Route path="edit-brand/:id" element={<FormBrand isEditMode />} />
        <Route path="clients" element={<ClientList />} />
        <Route path="create-client" element={<FormClient />} />
        <Route path="edit-client/:id" element={<FormClient isEditMode />} />
        <Route path="convenios" element={<ConvenioPage />} />
        <Route path="vales-troca" element={<DevolucoesPage />} />
        <Route path="fiscal/settings" element={<Navigate to="/establishments" replace />} />
        <Route path="fiscal/nfes" element={<NfeGerencialPage />} />
        <Route path="fiscal/manifesto" element={<NfeManifestoPage />} />
        <Route path="fiscal/importar-xml" element={<NfeXmlImportPage />} />
        <Route path="fiscal/cfops" element={<FiscalCatalogPage type="cfop" />} />
        <Route path="fiscal/ibpt" element={<FiscalCatalogPage type="ibpt" />} />
        <Route path="tax-groups" element={<TaxGroupList />} />
        <Route path="create-tax-group" element={<FormTaxGroup />} />
        <Route path="edit-tax-group/:id" element={<FormTaxGroup isEditMode />} />
        <Route path="stock-movement" element={<StockMovementList />} />
        <Route path="stock-movement/new" element={<FormStockMovement />} />
        <Route path="stock-movement/product/:id" element={<StockMovementList />} />
        <Route path="stock-movement/user/:id" element={<StockMovementList />} />
        <Route path="stock-locations" element={<LocaisEstoquePage />} />
        <Route path="stock-location-transfers" element={<Navigate to="/stock-transfers" replace />} />
        <Route path="stock-transfers" element={<TransferenciaEstoqueList />} />
        <Route path="stock-transfers/new" element={<FormTransferenciaEstoque isCreate />} />
        <Route path="stock-transfers/:id" element={<FormTransferenciaEstoque />} />
        <Route path="suppliers" element={<SupplierList />} />
        <Route path="suppliers/new" element={<FormSupplier />} />
        <Route path="edit-supplier/:id" element={<FormSupplier isEditMode />} />
        <Route path="transportadoras" element={<TransportadoraList />} />
        <Route path="campaigns" element={<CampaignList />} />
        <Route path="create-campaign" element={<FormCampaign />} />
        <Route path="edit-campaign/:id" element={<FormCampaign isEditMode />} />
        <Route path="pdvs" element={<PdvList />} />
        <Route path="pdvs/new" element={<PdvForm />} />
        <Route path="pdvs/:id/edit" element={<PdvForm />} />
        <Route path="payment-methods" element={<PaymentMethodList />} />
        <Route path="payment-methods/new" element={<FormPaymentMethod />} />
        <Route path="payment-methods/:id/edit" element={<FormPaymentMethod />} />
        <Route path="pix-integrations" element={<PixIntegrationList />} />
        <Route path="pix-integrations/new" element={<FormPixIntegration />} />
        <Route path="pix-integrations/:id/edit" element={<FormPixIntegration />} />
        <Route path="/establishments" element={<EstabelecimentoList/>} />
        <Route path="/establishments/:id/edit" element={<EstabelecimentoForm/>} />

      </Route>
    </Routes>
  );
}

export default App;
